import React from 'react';
import { CompanySelector } from '../../modules/tt-company-context';
import { Select } from 'tt-ui-lib/core';

/**
 * Wrapper for CompanySelector with tt-ui-lib Select component
 * Integrates with SSO backend API for multi-company management
 */
const CompanySelectorWrapper = ({ onCompanyChange, className, style }) => {
  const apiBaseUrl = process.env.REACT_APP_SSO_API || process.env.REACT_APP_SSO;
  const domainValue = process.env.REACT_APP_DOMAIN;

  const handleCompanyChange = (companyId) => {
    // Reload page to refresh all data with new company context
    window.location.reload();

    // If parent provides callback, call it
    if (onCompanyChange) {
      onCompanyChange(companyId);
    }
  };

  return (
    <CompanySelector
      apiBaseUrl={apiBaseUrl}
      domainValue={domainValue}
      onCompanyChange={handleCompanyChange}
      selectComponent={Select}
      className={className}
      style={style}
    />
  );
};

export default CompanySelectorWrapper;
